import Smartphones from './containers/Smartphones'
import Tablets from './containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const CreditsafeOnboardingView = getCurrentDeviceView(Smartphones, Tablets)

export default CreditsafeOnboardingView
